export const SUBSCRIPTION_PRICING_LABELS = {
  title: "Plans and pricing",
  subtitle: "Choose a billing cycle to compare plan prices.",
  currentPlan: "Current plan",
  trialActive: "Trial active",
  notAvailable: "Not available",
  freeTrial: "Free",
  trialAvailableChip: "Trial available",
  trialBadge: (days) => `${days}-day trial`,
  trialPeriod: (days) => `${days} days free`,
  noCreditCard: "No credit card required",
  perCycle: (label) => `per ${String(label || "").toLowerCase()}`,
  effectiveMonthly: (amount) => `${amount} / month effective`,
  billedMonthly: "Billed monthly",
  saveAmount: (amount) => `Save ${amount}`,
  chooseBillingCycle: "1. Choose billing cycle",
  selectPlan: "2. Select a plan",
  reviewAndContinue: "3. Review and continue",
  viewPlanComparison: "View complete plan comparison",
};
